export default __webpack_public_path__ + "static/media/sort-up.00d08185.svg";